import { bulkUpdate } from './utils/bulkUpdate';
import { useItems } from './utils/ItemsContext';
import { ActionsContent } from './utils/ActionsContent';
import PropTypes from 'prop-types';
import { SearchExistingAppliance } from '@components/FormComponents/ApplianceForm/SearchExistingAppliance';
import { useState } from 'react';

export const AssignHostAppliance = ({ title }) => {
  const { streams } = useItems();
  const [applianceId, setApplianceId] = useState('');

  return (
    <ActionsContent
      title={title}
      description='Search for an existing appliance. Once updated, all selected video streams will be reassigned to the new host appliance.'
      confirmAction={() => bulkUpdate('update_stream', streams, {
        applianceId: applianceId,
      })}
      confirmBtnState={streams.length > 0 ? 'default' : 'disabled'}
    >
      <SearchExistingAppliance
        formData={applianceId}
        fieldName='Host Appliance'
        setFormData={(applianceData) => {
          setApplianceId(applianceData?.id ?? '');
        }}
        required={false}
        noLabel
      />
    </ActionsContent>
  );
};

AssignHostAppliance.propTypes = {
  title: PropTypes.string.isRequired,
};